export const createHandleKeyPress = () => {
  return (event: React.KeyboardEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement;
    const currentLength = target.value.replace(/[^\d]/g, "").length;
    if (!/[0-9]/.test(event.key) || currentLength >= 10) {
      event.preventDefault();
    }
  };
};

export const createHandleEditKeyPress = () => {
  return (event: React.KeyboardEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement;
    const currentLength = target.value.replace(/[^\d]/g, "").length;
    if (!/[0-9\+]/.test(event.key) || currentLength >= 12) {
      event.preventDefault();
    }
  };
};

export const createHandlePinCodeKeyPress = () => {
  return (event: React.KeyboardEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement;
    const currentLength = target.value.replace(/[^\d]/g, "").length;
    if (!/[0-9]/.test(event.key) || currentLength >= 6) {
      event.preventDefault();
    }
  };
};
